import {Component} from '@angular/core';
import {GlobalsService} from "@services/micro/globals.service";
import { AmpassengerButtonSelectComponent } from '../ampassenger-button-select/ampassenger-button-select.component';
import { KioskPermissionsService } from '@services/kiosk-permissions.service';

/**
  Componente que extiende la funcionalidad de `AmpassengerButtonSelectComponent` para manejar
  la selección de pasajeros en el contexto de la gestión de equipaje.
  Este componente permite seleccionar o deseleccionar a un pasajero para la gestión de su equipaje
  y emite eventos cuando se realiza una selección.
**/
export type TypeTemplateButton = 'passenger' | 'bags';
@Component({
    selector: 'am-passenger-button-select-bags',
    templateUrl: './ampassenger-button-select-bags.component.html',
    styleUrls: ['./ampassenger-button-select-bags.component.scss'],
    standalone: false
})

export class AmpassengerButtonSelectBagsComponent extends AmpassengerButtonSelectComponent {

  constructor(
    public _global: GlobalsService,
    _kioskPermissions: KioskPermissionsService
  ) {
    super(_global, _kioskPermissions);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

   /**
    Maneja el evento de selección o deselección del pasajero para la gestión de equipaje.
    Actualiza el estado de selección del pasajero y emite el evento `selected`.
    @param {boolean} select - Indica si el pasajero ha sido seleccionado (`true`) o deseleccionado (`false`).
    @return void
  **/
  override onSelect(select: boolean): void {
    this.passanger.isSelectForBagagge = select;
    this.selected.emit(select);
  }
  //#endregion Eventos
}
